<template lang="pug">
	.caja-herramientas
		div(:class="(opciones.activoColocacion) ? '' : 'disabled'", @click="accion('colocacion')")
			span.fa.fa-puzzle-piece
			div.textoMenu Colocación
		div(:class="(opciones.activoInsertar) ? '' : 'disabled'", @click="accion('insertarOriginales')")
			span.fa.fa-plus-square
			div.textoMenu Insertar Originales
		div(:class="(opciones.activoRotacionV) ? '' : 'disabled'", @click="accion('rotacionVertical')")
			span.fa.fa-arrows-v
			div.textoMenu Rotación vertical
		div(:class="(opciones.activoRotacionH) ? '' : 'disabled'", @click="accion('copiarInserciones')")
			span.fa.fa-copy
			div.textoMenu Copiar a otro original
		div(:class="(opciones.activoAnulaIns) ? '' : 'disabled'", @click="accion('eliminarInserciones')")
			span.fa.fa-calendar-times-o
			div.textoMenu Anular inserciones
		div(:class="(opciones.activoRecuperaIns) ? '' : 'disabled'", @click="accion('recuperarInserciones')")
			span.fa.fa-calendar-plus-o
			div.textoMenu Recuperar inserciones
		div(:class="(opciones.activoModVarias) ? '' : 'disabled'")
			span.fa.fa-gears
			div.textoMenu Modificar varias
</template>


<script>
export default {
	props: ['linea'],
	computed: {
		colocacionCorrecta () {
			if (!this.linea) {
				return false
			}
			if (this.linea.ProgramaID) {
				return true
			} else if (this.linea.ContenidoID) {
				return true
			} else if (this.linea.HoraInicio && this.linea.HoraFin) {
				return true
			}
			return false
		},
		opciones () {
			const opt = {
				activoColocacion: false,
				activoInsertar: false,
				activoRotacionV: false,
				activoRotacionH: false,
				activoAnulaIns: false,
				activoRecuperaIns: false,
				activoModVarias: false
			}

			if (this.linea) {
				opt.activoColocacion = true
				opt.activoInsertar = true & this.colocacionCorrecta
				opt.activoRotacionV = true & this.colocacionCorrecta
				opt.activoRotacionH = true & this.colocacionCorrecta
				opt.activoAnulaIns = true & this.colocacionCorrecta
				opt.activoRecuperaIns = true & this.colocacionCorrecta
			}

			return opt
		}
	},
	methods: {
		accion (accion) {
			if (accion !== 'colocacion' && !this.colocacionCorrecta) {
				return
			}
			this.$emit('accion', accion)
		}
	}
}
</script>

<style scoped>
/* HERRAMIENTAS */
.caja-herramientas {
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  width: 100%;
  background-color: inherit;
  background-color: white;
  border: 1px solid #e0e0e0;
}

.caja-herramientas > div {
  flex: 1 auto;
  align-self: auto;
  border-left: none;
  /* width: 80px;
  max-width: 80px; */
  width: 50px;
  max-width: 50px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  margin-right: 5px;
  align-items: center;
  align-self: center;
  align-content: center;
  position: relative;
}

.caja-herramientas > div.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.caja-herramientas > div.disabled:hover {
  background-color: inherit;
  color: inherit;
}

.caja-herramientas > div:hover {
  background-color: darkred;
  color: white;
}

.caja-herramientas > div > span {
  font-size: 1.5em;
}
.caja-herramientas > div > div {
  font-size: 1em;
}

.textoMenu {
	position: absolute;
	display: none;
	top: 40px;
	left: 0;
	background-color: white;
	border: 1px solid #e0e0e0;
	border-radius: 2px;
	padding: 5px;
	box-shadow: 0 0 10px rgba(0,0,0,0.2);
	color: #333333;
	width: 150px;
}

.caja-herramientas > div:hover > .textoMenu {
	display: block;
}
</style>




// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/menu.vue